import { http } from "./http";

export type UploadSupportAttachmentResponse = {
  ok: boolean;
  url: string;
  fileName: string;
  contentType: string;
  size: number;
};

export const SupportAdminAPI = {
  async uploadAttachment(image: File) {
    const formData = new FormData();
    formData.append("image", image);
    const response = await http.post<UploadSupportAttachmentResponse>(
      "/support/admin/messages/attachment",
      formData,
    );
    return response.data;
  },
};
